// extracted by mini-css-extract-plugin
export var chevron = "_1p-d";
export var disabled = "_1p-b";
export var error = "_1p-c";
export var hideBorder = "_1p-1";
export var icon = "_1p-e";
export var input = "_1p-0";
export var large = "_1p-f";
export var open = "_1p-9";
export var placeholder = "_1p-a";
export var regular = "_1p-5";
export var singleRowInput = "_1p-2";
export var singleSelectInput = "_1p-3 _1p-0";
export var small = "_1p-4";
export var spinnerContainer = "_1p-i";
export var tag = "_1p-7";
export var tagsContainer = "_1p-8";
export var tagsInput = "_1p-6 _1p-0";
export var xSmall = "_1p-g";
export var xxSmall = "_1p-h";